import { FetchDetailOptions, FetchListOptions } from '~/api/_types';
import { FetchOrdersResponse, OrderDetail, OrderDraftDetail, OrderFormData } from '~/api/orders/_types';
import { ApiSimpleResponseContext, FormHandler } from '~/plugins/apiClient/_types';
import {
    deleteOrderDraftRequest,
    fetchOrderDetailDraftRequest,
    fetchOrderDetailRequest,
    fetchOrdersRequest,
    postOrderDraftRequest,
    postOrderRequest,
    revertOrderToDraftRequest,
} from '~/api/orders';
import { fetchAndStoreData, updateAndStoreFormData } from '../utils';
import router from '~/plugins/router';
import { useOrderDetailStore } from '~/stores/orderDetail';
import { useOrderDraftDetailStore } from '~/stores/orderDraftDetail';

export const fetchOrders = async (
    opt?: FetchListOptions
): Promise<ApiSimpleResponseContext<FetchOrdersResponse | null>> => {
    return await fetchOrdersRequest(opt);
};

export const fetchOrderDraftDetail = async (
    draftId: number,
    opt?: FetchDetailOptions
): Promise<ApiSimpleResponseContext<OrderDraftDetail | null>> => {
    return await fetchAndStoreData(
        router,
        'Id',
        draftId,
        getActiveOrderDraft,
        async () => await fetchOrderDetailDraftRequest(draftId),
        opt
    );
};

export const fetchOrderDetail = async (
    id: number,
    opt?: FetchDetailOptions
): Promise<ApiSimpleResponseContext<OrderDetail | null>> => {
    return await fetchAndStoreData(
        router,
        'Id',
        id,
        getActiveOrder,
        async () => await fetchOrderDetailRequest(id),
        opt
    );
};

export const sendOrder: FormHandler<OrderFormData, ApiSimpleResponseContext<OrderDetail | null>> = async (
    values,
    ctx
) => {
    return await updateAndStoreFormData(ctx, getActiveOrder, async () => await postOrderRequest(values));
};

export const saveOrderDraft: FormHandler<OrderFormData, ApiSimpleResponseContext<OrderDraftDetail | null>> = async (
    values,
    ctx
) => {
    return await updateAndStoreFormData(ctx, getActiveOrderDraft, async () => await postOrderDraftRequest(values));
};

export const deleteOrderDraft = async (id: number): Promise<ApiSimpleResponseContext<null>> => {
    return await deleteOrderDraftRequest(id);
};

export const revertOrderToDraft = async (id: number): Promise<ApiSimpleResponseContext<OrderDraftDetail>> => {
    return await revertOrderToDraftRequest(id);
};

const getActiveOrderDraft = () => storeToRefs(useOrderDraftDetailStore()).activeOrderDraft;
const getActiveOrder = () => storeToRefs(useOrderDetailStore()).activeOrder;
